/* eslint-disable */
export const meetings = [
    {
        id: '0001',
        meetingId: '0001',
        testMeetingId: '',
        subject: 'Test 1',
        startTime: '2022-10-05T08:00:00.000Z',
        endTime: '2022-10-05T11:45:00.000Z',
        duration: '30 mins',
        status: 'Active',
        createdAt: '2022-10-05T12:00:00.000Z',
        createdBy: 'Aravind Makam',
        invitees: [{
            id: '0001',
            name: 'Aravind Makam',
            email: 'makamaravind6@gmail.com',
            company: 'Prestine Technologies Pvt.Ltd',
            phoneNo: '9059134362',
            avatarUrl: 'assets/images/avatars/male-07.jpg'
        }],
        participants: [{
            id: '0001',
            name: 'Aravind Makam',
            email: 'makamaravind6@gmail.com',
            company: 'Prestine Technologies Pvt.Ltd',
            phoneNo: '9059134362',
            avatarUrl: 'assets/images/avatars/male-07.jpg'
        }],
        contentId: '0001',
        description: 'Testing the meeting',
        meetingLink: '',
        testMeetingLink: '',
        escore: 70
    },
    {
        id: '0002',
        meetingId: '0002',
        testMeetingId: '',
        subject: 'Test 2',
        startTime: '2022-10-05T13:00:00.000Z',
        endTime: '2022-10-05T13:30:00.000Z',
        duration: '30 mins',
        status: 'Pending',
        createdAt: '2022-10-05T12:00:00.000Z',
        createdBy: 'Aravind Makam',
        invitees: [{
            id: '0001',
            name: 'Aravind Makam',
            email: 'makamaravind6@gmail.com',
            company: 'Prestine Technologies Pvt.Ltd',
            phoneNo: '9059134362',
            avatarUrl: 'assets/images/avatars/male-07.jpg'
        },
        {
            id: '0002',
            name: 'Dhananjaya CK',
            email: 'djoyrocks@gmail.com',
            company: 'Prestine Technologies Pvt.Ltd',
            phoneNo: '9686577705',
            avatarUrl: 'assets/images/avatars/male-07.jpg'
        },
        {
            id: '0003',
            name: 'Mujeeb',
            email: 'mujeebkhank786@gmail.com',
            company: 'Prestine Technologies Pvt.Ltd',
            phoneNo: '7893858578',
            avatarUrl: 'assets/images/avatars/male-07.jpg'
        }],
        participants: [{
            id: '0001',
            name: 'Aravind Makam',
            email: 'makamaravind6@gmail.com',
            company: 'Prestine Technologies Pvt.Ltd',
            phoneNo: '9059134362',
            avatarUrl: 'assets/images/avatars/male-07.jpg'
        },
        {
            id: '0002',
            name: 'Dhananjaya CK',
            email: 'djoyrocks@gmail.com',
            company: 'Prestine Technologies Pvt.Ltd',
            phoneNo: '9686577705',
            avatarUrl: 'assets/images/avatars/male-07.jpg'
        },
        {
            id: '0003',
            name: 'Mujeeb',
            email: 'mujeebkhank786@gmail.com',
            company: 'Prestine Technologies Pvt.Ltd',
            phoneNo: '7893858578',
            avatarUrl: 'assets/images/avatars/male-07.jpg'
        }],
        contentId: '0002',
        description: 'Testing the meeting',
        meetingLink: '',
        testMeetingLink: '',
        escore: 50
    },
    {
        id: '0003',
        meetingId: '0003',
        testMeetingId: '',
        subject: 'Test 3',
        startTime: '2022-10-05T12:00:00.000Z',
        endTime: '2022-10-05T12:30:00.000Z',
        duration: '30 mins',
        status: 'Completed',
        createdAt: '2022-10-05T12:00:00.000Z',
        createdBy: 'Aravind Makam',
        invitees: [{
            id: '0001',
            name: 'Aravind Makam',
            email: 'makamaravind6@gmail.com',
            company: 'Prestine Technologies Pvt.Ltd',
            phoneNo: '9059134362',
            avatarUrl: 'assets/images/avatars/male-07.jpg'
        },
        {
            id: '0002',
            name: 'Dhananjaya CK',
            email: 'djoyrocks@gmail.com',
            company: 'Prestine Technologies Pvt.Ltd',
            phoneNo: '9686577705',
            avatarUrl: 'assets/images/avatars/male-07.jpg'
        }],
        participants: [{
            id: '0001',
            name: 'Aravind Makam',
            email: 'makamaravind6@gmail.com',
            company: 'Prestine Technologies Pvt.Ltd',
            phoneNo: '9059134362',
            avatarUrl: 'assets/images/avatars/male-07.jpg'
        },
        {
            id: '0002',
            name: 'Dhananjaya CK',
            email: 'djoyrocks@gmail.com',
            company: 'Prestine Technologies Pvt.Ltd',
            phoneNo: '9686577705',
            avatarUrl: 'assets/images/avatars/male-07.jpg'
        }],
        contentId: '0003',
        description: 'Testing the meeting',
        meetingLink: 'awvent.com/meeting/2',
        testMeetingLink: '',
        escore: 25
    }
];
